export const statsApiEndpoints = {
    action: 'https://actionv1-jjjo3e5ofa-ew.a.run.app',
    connect: 'https://connectv1-jjjo3e5ofa-ew.a.run.app',
    updateLog: 'https://updatelogv1-jjjo3e5ofa-ew.a.run.app',
    versionCheck: 'https://versioncheckv1-jjjo3e5ofa-ew.a.run.app',
} as const;

const statsApiHost = 'jjjo3e5ofa-ew.a.run.app';

export const isStatsApiEndpoint = (url: string): boolean => url.includes(statsApiHost);
